export const loadState = (key) => {
    try {
      const serializedState = localStorage.getItem(key);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      console.error("Could not load state", err);
      return undefined;
    }
  };
  
  export const saveState = (key, state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch (err) {
      console.error("Could not save state", err);
    }
  };
  
  export const removeState = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error("Could not remove state", err);
    }
  };
  